// Module
var code = "<div> <div class=\"print\" ng-if=\"printContent\"> {{ printContent }} </div> <ng-transclude></ng-transclude> </div> ";
// Exports
export default code;